import * as z from "zod";

/**
 * Resolve a POS scanner code (barcode or SKU) to exactly one variant.
 * Resolution only — eligibility comes from hydrating via searchExchangeProducts.
 */
export const resolveScannedCode = {
  name: "resolveScannedCode" as const,
  input: z.object({ code: z.string() }),
  output: z.discriminatedUnion("outcome", [
    z.object({ outcome: z.literal("not_found") }),
    z.object({ outcome: z.literal("ambiguous") }),
    z.object({
      outcome: z.literal("resolved"),
      variantId: z.string(),
      productId: z.string(),
    }),
  ]),
};
